import { memo as Memo } from 'react';

//* HOCs
import withLanguageContext from 'context/consumerHOC/LanguageConsumer';

//* Components
import Container from 'components/common/Container';
import Text from 'components/common/Text';
import Image from 'components/common/Image';
import Button from 'components/common/Button';

//* Styles
import ProductHeroSectionStyle from './style';

const ProductHeroSection = Memo(({ name, text, availableIn, alcoholVolume, image, btnUrl, translate, hasBackground = false }) => {
	return (
		<ProductHeroSectionStyle className={hasBackground ? 'white-bg' : ''}>
			<Container>
				<Button
					url={btnUrl}
					className='phs-back-btn'
					btnType='with-lottie'
					text={'backToProducts'}
				/>
			</Container>

			<Container
				row
				className='phs-cont'>
				<div className='col-6 col-ts-12 phs-image-col'>
					<div className='phs-image-cont'>
						<Image
							src={image?.src}
							alt={image?.alt}
							className={'contain'}
						/>
					</div>
				</div>

				<div className='col-4 col-ds-5 col-t-6 col-ts-12 phs-info-col'>
					<div className='phs-info-cont primary-color9'>
						{/* {collection ? (
							<Text
								tag='h2'
								text={collection}
								className='phs-collection p p2 notoSans-regular'
							/>
						) : null} */}

						<Text
							tag='h1'
							text={name}
							className='phs-name h5 minion3-medium uppercase'
						/>

						<Text
							tag='h3'
							text={text}
							className='phs-text p p4 notoSans-regular'
						/>

						<div className='phs-about-product row'>
							{availableIn?.length ? (
								<div className='col-7 col-t-12 col-ts-7 col-m-12'>
									<Text
										tag='h3'
										text={'availableIn'}
										className='phs-available-title uppercase p p4 notoSans-regular'
									/>
									<Text
										tag='h3'
										className='phs-available-text p p4 notoSans-regular'>
										{availableIn?.map((i, k) => (
											<span key={k}>{`${i}${k < availableIn.length - 1 ? ` | ` : ''}`}</span>
										))}
									</Text>
								</div>
							) : null}
							{alcoholVolume ? (
								<div className='col-5 col-t-12 col-ts-5 col-m-12'>
									<Text
										tag='h3'
										text={'alcohol'}
										className='phs-alcohol-title uppercase p p4 notoSans-regular'
									/>

									<div className='phs-alcohol-info-cont'>
										<Text
											tag='h3'
											text={alcoholVolume}
											className='phs-alcohol-text p p4 notoSans-regular'>
											<span className='phs-circle'>{alcoholVolume}%</span>
											{translate('byVolume')}
										</Text>
									</div>
								</div>
							) : null}
						</div>
					</div>
				</div>
			</Container>
		</ProductHeroSectionStyle>
	);
});

export default withLanguageContext(ProductHeroSection, ['translate']);
